<template>
  <v-layout>
    <v-flex>

      <v-toolbar class="elevation-1">
        <h3 class="title">{{ title }}</h3>
        <v-btn @click="fetchData()" small>
          Обновить
          <v-icon right small>mdi-refresh</v-icon>
        </v-btn>
        <v-spacer/>
      </v-toolbar>

      <v-card>
        <v-card-title>
          <v-text-field
                  v-model.trim="search"
                  append-icon="search"
                  label="Поиск по ЕДРПОУ, ДРФО, Названию"
                  single-line
                  hide-details
          ></v-text-field>
          <v-menu
              ref="start_date_menu"
              :close-on-content-click="false"
              v-model="start_date_menu"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width>
            <v-text-field
                    slot="activator"
                    v-model="start_date"
                    label="Нач. дата"
                    prepend-icon="event"
                    signle-line
                    hide-details
                    readonly
            ></v-text-field>
            <v-date-picker v-model="start_date" locale="ru-ru" @input="$refs.start_date_menu.save(start_date)"></v-date-picker>
          </v-menu>
          <v-menu
            ref="end_date_menu"
            :close-on-content-click="false"
            v-model="end_date_menu"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width>
            <v-text-field
                    slot="activator"
                    v-model="end_date"
                    label="Кон. дата"
                    prepend-icon="event"
                    signle-line
                    hide-details
                    readonly
            ></v-text-field>
            <v-date-picker v-model="end_date" locale="ru-ru" @input="$refs.end_date_menu.save(end_date)"></v-date-picker>
          </v-menu>
          <v-btn small icon color="light-blue darken-3" dark @click="clearFilter()"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="documents"
                no-data-text="Документы отсутствуют"
                hide-actions
                dense
                :loading="loading"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>
                <router-link :to="{name: mode+'_document_detail', params: {document_id: props.item.id}}">
                  <b v-if="!props.item.is_seen">{{ props.item.name }}</b>
                  <template v-else>{{ props.item.name }}</template>
                </router-link>

                <v-menu offset-y>
                  <v-btn
                          slot="activator"
                          color="primary"
                          icon
                          flat
                  >
                    <v-icon small>mdi-menu</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile :href="props.item.archive_url+access_token">
                      <v-list-tile-title>Скачать архив с подписями</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile :href="props.item.original_url+access_token">
                      <v-list-tile-title>Скачать оригинал документа</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </td>
              <td>
                <template v-if="props.item.status === 'inbox'">
                  <span v-if="props.item.sender_edrpou != ''">{{props.item.sender_edrpou}}</span>
                  <span v-if="props.item.sender_drfo != ''"> / {{props.item.sender_drfo}}</span>
                </template>
                <template v-if="props.item.status === 'sent'">
                  <span v-if="props.item.receiver_edrpou != ''">{{props.item.receiver_edrpou}}</span>
                  <span v-if="props.item.receiver_drfo != ''"> / {{props.item.receiver_drfo}}</span>
                </template>
              </td>
              <td>
                <v-menu offset-y v-if="props.item.signs.length > 0">
                  <v-btn
                          slot="activator"
                          color="green"
                          icon
                          flat
                  >
                    <v-icon small>mdi-lock</v-icon> x {{ props.item.signs.length }}
                  </v-btn>
                  <v-list>
                    <v-list-tile v-for="sign in props.item.signs" :key="'sign_'+sign.drfo+sign.edrpou">
                      <v-list-tile-action>
                        <v-icon>mdi-account</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ sign.organization }} {{ sign.name }},
                          <template v-if="sign.edrpou">ЕДРПОУ: {{ sign.edrpou }}</template>
                          <template v-if="sign.drfo">ДРФО: {{ sign.drfo }}</template>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          Файл подписи: <a :href="addToken(sign.url)">{{ sign.filename }}</a>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </td>
              <td>{{ props.item.created_at | date }}</td>
              <td>{{ prettyBytes(props.item.size) }}</td>
            </tr>
          </template>
        </v-data-table>
        <v-btn block flat @click="moreDownload()" :loading="more_loading" v-if="documents_next !== null">Ещё</v-btn>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import prettyBytes from 'pretty-bytes'
import _ from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'DocumentList',
  props: ['title', 'mode', 'inbox_name'],
  data () {
    return {
      more_loading: false,
      search: '',
      loading: false,
      start_date_menu: null,
      end_date_menu: null,
      start_date: null,
      end_date: null,
      sign_dialog: false,
      sign_info_dialog: false,
      sign_info_document: {
        name: '',
        signs: []
      },
      delete_dialog: false,
      send_dialog: false,
      selected: [],
      headers: this.renderHeaders()
    }
  },
  methods: {
    renderHeaders() {
      return [
          {
            text: 'Название',
            value: 'name',
            sortable: false
          },
          {
            text: this.inbox_name,
            value: 'size',
            sortable: false
          },
          {
            text: 'Подпись',
            value: 'size',
            sortable: false
          },
          {
            text: 'Дата загрузки',
            value: 'created_at',
            sortable: false
          },
          {
            text: 'Размер',
            value: 'size',
            sortable: false
          }
        ]
    },
    prettyBytes(size) {
      return prettyBytes(size)
    },
    fetchData() {
      this.headers = this.renderHeaders()
      this.loading = true
      this.$store.dispatch('getDocumentList',
        {
          mode: this.mode,
          search: this.search,
          start_date: this.start_date,
          end_date: this.end_date
        })
        .finally(() => { this.loading = false })
    },
    moreDownload() {
      this.more_loading = true
      this.$store.dispatch('nextDocumentList')
        .finally(() => { this.more_loading = false})
    },
    resetFilter() {
      this.search = ''
      this.start_date = null
      this.end_date = null
    },
    clearFilter() {
      this.resetFilter()
    },
    changeView() {
      this.fetchData()
    },
    addToken(val) {
      return `${val}?access_token=`+localStorage.getItem('token')
    }
  },
  computed: {
    ...mapState(['documents', 'documents_next', 'cas', 'eusign']),
    access_token () {
      return '?access_token='+localStorage.getItem('token')
    }
  },
  watch: {
    $route: 'changeView',
    search: function() {
      this.debouncedFetchData()
    },
    start_date: function() {
      this.debouncedFetchData()
    },
    end_date: function() {
      this.debouncedFetchData()
    }
  },
  created() {
    this.fetchData()
    this.debouncedFetchData = _.debounce(this.fetchData, 500)
  }
}
</script>
